import { Backdrop, CircularProgress } from "@mui/material";

export default ({ open }: { open: boolean }) => {
  return (
    <Backdrop
      open={open}
      style={{
        zIndex: 1398,
        backgroundColor: "rgba(0, 0, 0, 0.75)",
      }}
    >
      <CircularProgress
        style={{
          zIndex: 1399,
          color: "#A9A9A9",
        }}
      />
    </Backdrop>
  );
};
